<template>
  <div
    class="listing-result-condominium listing-result"
    :data-listing-id="listing.id"
    :class="`${hoverOff ? 'hoverOff' : ''} ${isSelected ? 'is-selected' : ''}`"
    v-on:mouseenter="$emit('hoverResult', listing.id)"
    v-on:mouseleave="$emit('hoverResult', false)"
  >
    <!-- NOTE: attribute data-id is also in use by analytics for fb ads so do not change it -->
    <a
      class="listing-result__link"
      :data-path="listingPath"
      :id="listing.id"
      :data-id="listing.id"
      @click.prevent="navigateToListingPage(listing.id)"
      :href="listingPath"
      @focus="$emit('focus')"
    >
      <!-- Image -->
      <div
        :class="`listing-result-condominium__image ${listing.imageUrl ? '' : 'placeholder'}`"
        :style="`background-image: url(${listing.imageUrl || 'https://op-koti.fi/assets/image-placeholder2.svg'})`"
      >
        <div class="logo-banner" v-if="isNewsecListing()" v-html="newsecLogo"></div>
        <div class="logo-banner op" v-else></div>
      </div>

      <!-- Address -->
      <div class="listing-result-condominium__detail-row">
        <span class="new-housing-logo">Uudiskohde</span>

        <span class="condominium-name" :title="listing.newHousing.name || listing.location.streetAddress.trim()">
          {{ listing.newHousing.name || listing.location.streetAddress.trim() }}
        </span>

        <span class="listing-result__street">
          {{ listing.location.streetAddress.trim() }}
          <span class="desktop-comma">,</span>
        </span>
        <br />
        <!--
        -->
        <span class="listing-result__district" v-if="listing.location.district">{{ listing.location.district }},</span>
        <!--
        -->
        <span class="listing-result__city" v-if="listing.location.city">
          {{ listing.location.city }}
        </span>

        <span class="listing-result-condominium__showings" v-if="listing.showings">
          <showings :showings="listing.showings" :show-end-time="true"></showings>
        </span>
      </div>
    </a>

    <div class="listing-result__icons">
      <a
        @click="stopBubbling($event)"
        v-if="listing.virtualPresentationUrl"
        :href="listing.virtualPresentationUrl"
        target="_blank"
      >
        <i class="listing-result__icon icon-virtual"></i>
      </a>
      <a @click="stopBubbling($event)" v-if="listing.videoUrl" :href="listing.videoUrl" target="_blank">
        <i class="listing-result__icon icon-videoclip-circled"></i>
      </a>
    </div>
  </div>
</template>
<script lang="ts">
import config from '@/config';
import router from '../../router';
import { condominium as condominiumRoute, condominium } from '@/app/routes';
import Showings from '../showings/showings.vue';
import useSafeRoute from '@/app/composables/useSafeRoute';
import { defineComponent } from 'vue';
import NewsecLogo from '@/app/icons/newsec_rgb.svg';

export default defineComponent({
  name: 'condominium-result',
  setup() {
    const route = useSafeRoute();
    return { route };
  },
  components: { Showings },
  data: () => ({
    config,
    newsecLogo: NewsecLogo,
    condominiumRoute,
    elementHasHover: false,
    preventDelayedSelection: false,
    preventDelayedUnselection: false,
  }),
  props: {
    listing: {
      type: Object,
      required: true,
    },
    hoverOff: {
      type: Boolean,
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    listingPath() {
      return `${condominium.path}/${this.listing.id}`;
    },
  },
  methods: {
    isNewsecListing() {
      return this.listing.source === config.LISTING_SOURCES.NEWSEC;
    },
    stopBubbling(event: Event) {
      event.stopPropagation();
    },
    navigateToListingPage(id: string) {
      void router.push(`${condominiumRoute.path}/${id}`);
    },
  },
});
</script>
